<template></template>

<script>
import { Store } from "../stores/store.js";
import { mapWritableState } from "pinia";
import axios from 'axios';

export default {
    computed: {
        ...mapWritableState(Store, ["visitorData", "authUser"]),
    },
    async mounted() {
        try {
            window.tracker = new EventTracker();
            window.tracker.load({ endpoint: import.meta.env.VITE_FGPT_API_EVENTS_URL ?? 'https://tckr.ticto.cloud/api/events'});
            let authId = localStorage.getItem('auth_id');
            const visitorId = await window.tracker.takeVisitorProperty('page_view', {}, 'visitor_id');
            axios.defaults.headers.common["X-FingerprintJS-Token"] = visitorId;
            
            if (authId) {
                window.tracker.track('custom_event', { linked_id: authId });
            }

            if (visitorId) {
                console.log('Visitor ID:', visitorId);
            }
        } catch (error) {
            console.error('Error loading EventTracker:', error);
        }
    },
};
</script>
